import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

// @mui
import { Box, Card, CardHeader } from '@mui/material';

import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

// components
import { useChart } from '../chart';
// utils
import { fShortenNumber } from '../../utils/formatNumber';

// ----------------------------------------------------------------------

BarChart.propTypes = {
  title: PropTypes.string,
  subheader: PropTypes.string,
  chartData: PropTypes.array.isRequired,
  chartStyle: PropTypes.object,
  isvertical: PropTypes.bool,
  height: PropTypes.number,
  colors: PropTypes.array,
};

export default function BarChart({
  title,
  subheader,
  chartData,
  isvertical,
  height = 364,
  colors,
  ...other
}) {
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();
  const chartLabels = chartData.map((i) => i.label);

  const chartSeries = chartData.map((i) => i.value);

  const chartOptions = useChart({
    colors: colors || undefined,
    tooltip: {
      marker: { show: false },
      y: {
        formatter: (seriesName) => fShortenNumber(seriesName),
        title: {
          formatter: () => '',
        },
      },
    },
    plotOptions: {
      bar: { horizontal: !isvertical, barHeight: '28%', borderRadius: 2 },
      labels: {
        style: {
          fontSize: isSmallScreen ? '0.675rem' : '0.8rem',
        },
      },
    },
    xaxis: {
      categories: chartLabels.length > 0 ? chartLabels : [t('dashboard.noData')],
      labels: {
        style: {
          fontSize: isSmallScreen ? '0.675rem' : '0.8rem',
        },
      },
    },
  });

  return (
    <Card {...other}>
      <CardHeader
        title={title}
        subheader={subheader}
        sx={{
          '& .MuiCardHeader-title': { fontSize: isSmallScreen && '0.8rem' },
          '& .MuiCardHeader-subheader': { fontSize: isSmallScreen && '0.7rem' },
        }}
      />

      <Box sx={{ mx: 3 }} dir="ltr">
        <ReactApexChart
          type="bar"
          series={[{ data: chartSeries }]}
          options={chartOptions}
          height={height}
        />
      </Box>
    </Card>
  );
}
